import React from 'react';

import Button from './Button';

export default function Author({ author, version = 'tertiary-text' }) {
  const { firstName, lastName } = author;
  return (
    <>
      {author && (
        <Button
          button={{
            version,
            article: author,
            label: `${firstName} ${lastName}`,
            additionalClassNames: '--light'
          }}
        ></Button>
      )}
    </>
  );
}
